import EditActTeam from './EditActTeam';

export default EditActTeam;
